import { render, staticRenderFns } from "./FollowedChip.vue?vue&type=template&id=e3961bc2"
import script from "./FollowedChip.vue?vue&type=script&lang=js"
export * from "./FollowedChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports